class Config {
    //static host = 'http://localhost/NicoBurger/Backend';
    static host = 'https://nicoburger.folustecno.com//Backend';

}

export default Config